import { HttpClient, HttpHeaders  } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})

export class LogoutFromLMSService {
    constructor(private http: HttpClient) { }

    logoutUser(userId: number) {
        const url = 'https://academy-lms.learnyhome.com/academy/logout/';
        const headers = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded',
            'User-Agent': 'Mozilla/5.0'
        });
        const body = { id: userId };

        return this.http.post(url, body);
    }
}